import {animate, AnimationTriggerMetadata, style, transition, trigger} from "@angular/animations";

export function FadeInOut(height: boolean = false): AnimationTriggerMetadata  {
  return trigger('fadeInOut', [
    transition(':enter', [
      style(height ? { opacity: 0 , height: 0, } : { opacity: 0, }),
      animate("200ms ease-in", style(height ? { opacity: 1, height: '*' } : { opacity: 1, })),
    ]),
    transition(':leave', [
      style(height ? { opacity: 1 , height: '*', } : { opacity: 1, }),
      animate("200ms ease-in", style(height ? { opacity: 0, height: 0 } : { opacity: 1, })),
    ]),
  ]);
}


